export default function EmailLink({ email }) {
  if (!email) return null;
  return <a href={`mailto:${encodeURIComponent(email)}`} onClick={(event) => event.stopPropagation()}>{email}</a>;
}
